<template>
  <div class="project-request">
    <actions-bar>
      <div class="level">
        <div class="level-left">
          <h1 class="page-title">Project Request Form</h1>
        </div>
        <div v-if="preview" class="level-right">
          <div class="level-item">
            <div class="page-title">
              PREVIEW FORM
            </div>
          </div>
        </div>
      </div>
    </actions-bar>
    <div class="container">
      <h1 class="title">{{ form.title }}</h1>
      <div class="content">
        {{ form.description }}
      </div>
      <question
        v-for="(q, idx) in form.formQuestions"
        :key="`formQuestion-${idx}`"
        v-model="data.responses[getResponseIndex(q, idx)]"
        :question="q"
        answer
      ></question>
    </div>
  </div>
</template>

<script>
import ActionsBar from '@/components/ActionsBar';
import isEqual from 'lodash/isEqual';
import findIndex from 'lodash/findIndex';
import Question from '@/components/projectRequests/Question.vue';

export default {
  name: 'ProjectRequest',
  components: { ActionsBar, Question },
  props: {
    value: {},
    form: {},
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: this.value || {}
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          this.data = this.value;
        }
      }
    },
    data: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          this.$emit('input', this.data);
        }
      }
    }
  },
  mounted() {
    if (this.data.responses == undefined) {
      this.$set(this.data, 'responses', []);
    }
  },
  methods: {
    getResponseIndex(q, index) {
      let idx = findIndex(this.data.responses, {
        formQuestionID: q.formQuestionID || index
      });
      if (idx == -1) {
        idx =
          this.data.responses.push({
            formQuestionID: q.formQuestionID || index,
            responseText: '',
            responseChoices: []
          }) - 1;
      }
      return idx;
    }
  }
};
</script>

<style lang="scss">
.project-request {
  .page-actions-bar {
    margin-bottom: $block-spacing;
  }
  .choice-wrapper {
    display: block;
    margin-left: 0;
    &:not(:last-child) {
      margin-bottom: $block-spacing / 2;
    }
  }
}
</style>
